import { LOCALES } from '../locales';
export default {
    [LOCALES.EHGLISH]: {
        'hello': 'Hello',
        "Continue": "Continue"
    }
}